import React from "react";

const Spacer = ({ style }) => <div style={style} className="spacer"></div>

export default Spacer